import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import SearchFieldSelectionContainer from './SearchFieldSelectionContainer';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import CloseIcon from 'components/pure/utils/icon/CloseIcon';
import SearchFieldStore from 'stores/triggers/SearchFieldStore';
import SearchFieldActions from 'actions/triggers/SearchFieldActions';
import capitalized from 'components/triggers/search-field-selection/capitalized';

class SearchFieldSelectionViewRow extends React.Component {
  constructor(props) {
    super(props);

    this.toggleSelection = this.toggleSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
    this.renderDescription = this.renderDescription.bind(this);

    this.state = {
      selectionVisible: false,
      previousContext: null,
    };
  }

  toggleSelection() {
    this.setState({
      selectionVisible: true,
    });
  }

  componentDidMount() {
    if (this.props.context) {
      this.setState({previousContext: this.props.context});
    }
  }

  closeSelection() {
    this.setState({
      selectionVisible: false,
    });
    this.state.previousContext && this.props.updateContext(this.state.previousContext);
  }

  saveSelection(context, close = true) {
    if (close) {
      this.setState({
        selectionVisible: false,
        previousContext: context,
      });
    }

    this.props.updateContext(context);
  }

  renderDescription(context, defaultText, showSearchField, needsEither) {
    const {searchFields} = this.props;
    if (context && context.type === undefined) {
      return <span>{defaultText}</span>;
    }
    // == is intended here
    const field = searchFields.find(f => f.fieldDefinition.value === context.searchFieldId);
    if (field) {
      const option = field.fieldOptions.find(o => o.value === context.enumValue);
      return (
        option && (
          <span>
            {showSearchField
              ? `${capitalized(field.fieldDefinition.label)} was ${needsEither ? 'either ' : ''}`
              : ' or '}
            <span className="condition-action" onClick={this.toggleSelection}>
              {option.label}
            </span>
          </span>
        )
      );
    }
    return null;
  }

  render() {
    const {context, label, defaultText, showSearchField, needsEither, searchFields} = this.props;
    if (!searchFields) {
      return null;
    }
    return (
      <div className="search-field-view">
        {label}
        {this.renderDescription(context, defaultText, showSearchField, needsEither)}
        {this.state.selectionVisible && (
          <div className="create-rule-popout edit-popout">
            <SearchFieldSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={context => this.saveSelection(context, false)}
              closeRequest={this.closeSelection}
              selectedField={context && context.searchFieldId}
              selectedOption={context && context.enumValue}
            />
          </div>
        )}
      </div>
    );
  }
}

@connectToStores
class SearchFieldSelectionView extends React.Component {
  static getStores() {
    return [SearchFieldStore];
  }

  static getPropsFromStores() {
    const searchFieldStore = SearchFieldStore.getState();
    return {
      searchFields: searchFieldStore.searchFields,
      searchFieldsLoading: searchFieldStore.searchFieldsLoading,
      searchFieldsLoaded: searchFieldStore.searchFieldsLoaded,
    };
  }

  componentDidMount() {
    if (!this.props.searchFieldsLoaded && !this.props.searchFieldsLoading) {
      SearchFieldActions.fetchSearchFields();
    }
  }

  render() {
    const {matchAny, newContext, defaultText, searchFields} = this.props;
    const seen = {};
    const counts = matchAny ? matchAny.countBy(context => context.searchFieldId) : 0;
    const renderContext = (context, i) => {
      const retval = (
        <li key={i}>
          <SearchFieldSelectionViewRow
            context={context}
            label={i > 0 && !seen[context.searchFieldId] ? 'or ' : ''}
            updateContext={newContext => this.props.updateItem(i, newContext)}
            showSearchField={!seen[context.searchFieldId]}
            needsEither={counts.get(context.searchFieldId) > 1}
            searchFields={searchFields}
          />
          {i === matchAny.size - 1 && (
            <div className="or-button" onClick={this.props.orClick}>
              or
            </div>
          )}
          <div className="delete" onClick={() => this.props.removeItem(i)}>
            <CloseIcon />
          </div>
        </li>
      );
      seen[context.searchFieldId] = true;
      return retval;
    };
    return (
      <div className="rule-option-list">
        <ul>
          {matchAny &&
            matchAny
              .sortBy(context => context.enumValue)
              .sortBy(
                context =>
                  searchFields.find(f => f.fieldDefinition.value === context.searchFieldId)
                    .fieldDefinition.label
              )
              .map(renderContext)}
          {newContext != null && (
            <li>
              <SearchFieldSelectionViewRow
                context={newContext}
                defaultText={defaultText}
                label={matchAny && matchAny.size > 0 ? 'or ' : ''}
                searchFields={searchFields}
                showSearchField={true}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default class SearchFieldSelectionViewPlusButton extends React.Component {
  constructor(props) {
    super(props);

    this.toggleSelection = this.toggleSelection.bind(this);
    this.closeSelection = this.closeSelection.bind(this);
    this.saveSelection = this.saveSelection.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
    this.renderDescription = this.renderDescription.bind(this);

    this.state = {
      selectionVisible: false,
      newContext: null,
    };
  }

  toggleSelection() {
    this.props.onSelect(!this.state.selectionVisible);
    const newContext = !this.state.selectionVisible ? {} : null;
    this.setState({
      selectionVisible: !this.state.selectionVisible,
      newContext,
    });
  }

  closeSelection(reason) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
  }

  saveSelection(context) {
    this.props.onSelect(false);
    this.setState({
      selectionVisible: false,
      newContext: null,
    });
    this.props.addItem(context);
  }

  updateSelection(context) {
    this.setState({newContext: context});
  }

  renderDescription() {
    const {selectionVisible, newContext} = this.state;
    const {matchAny} = this.props;
    return newContext == null && (!matchAny || matchAny.size === 0) ? (
      <TriggerIconButton
        className="matching-search-field"
        label="has a field with a specific value"
        onClick={this.toggleSelection}
        active={selectionVisible}
      />
    ) : (
      <SearchFieldSelectionView
        {...this.props}
        defaultText="Has a field with a specific value"
        newContext={newContext}
        orClick={this.toggleSelection}
      />
    );
  }

  render() {
    const {selectionVisible} = this.state;
    return (
      <div className="rule-context-view">
        {this.renderDescription()}
        {selectionVisible && (
          <div className="create-rule-popout">
            <SearchFieldSelectionContainer
              saveSelection={this.saveSelection}
              updateSelection={this.updateSelection}
              saveOnSelect={false}
              closeRequest={this.closeSelection}
            />
          </div>
        )}
      </div>
    );
  }
}
